import { render, staticRenderFns } from "./CreateSupplierPopUp.vue?vue&type=template&id=56cd9b08&scoped=true&"
import script from "./CreateSupplierPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSupplierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSupplierPopUp.vue?vue&type=style&index=0&id=56cd9b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd9b08",
  null
  
)

export default component.exports